import { render, staticRenderFns } from "./requirementDetails.vue?vue&type=template&id=f507e12e&scoped=true"
import script from "./requirementDetails.vue?vue&type=script&lang=js"
export * from "./requirementDetails.vue?vue&type=script&lang=js"
import style0 from "./requirementDetails.vue?vue&type=style&index=0&id=f507e12e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f507e12e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f507e12e')) {
      api.createRecord('f507e12e', component.options)
    } else {
      api.reload('f507e12e', component.options)
    }
    module.hot.accept("./requirementDetails.vue?vue&type=template&id=f507e12e&scoped=true", function () {
      api.rerender('f507e12e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/requirementAnalysis/requirementDetails.vue"
export default component.exports